/* Mobile sticky-header CLS fix — 2026-07-27. See bs-header-cls-fix.css. */
(function () {
  var MQ = '(max-width: 768px)';
  var root = document.documentElement;

  function measure() {
    var wrap = document.querySelector('.cc-header--sticky');
    if (!wrap) return;

    if (!window.matchMedia(MQ).matches) {
      root.classList.remove('bs-hdr-fix');
      return;
    }

    var header = wrap.querySelector('store-header');
    // never latch the collapsed height as the reserve
    if (header && header.classList.contains('is-out')) return;

    root.classList.remove('bs-hdr-fix');
    var h = Math.round(wrap.getBoundingClientRect().height);
    if (h > 0) {
      root.style.setProperty('--bs-header-reserve', h + 'px');
      root.classList.add('bs-hdr-fix');
    }
  }

  var t;
  function debounced() {
    clearTimeout(t);
    t = setTimeout(measure, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', measure);
  } else {
    measure();
  }
  window.addEventListener('load', measure);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  window.addEventListener('resize', debounced);
  window.addEventListener('orientationchange', debounced);
})();
